<fplib-common-headers [isShowNotify]="false" [isSharedlayout]="false" [activeCurrentTheme]="'Dark'" [menusBaseUrl]="menusBaseUrl"></fplib-common-headers>
<main>
	<router-outlet />
</main>
<fpl-ask-update-modal />
<fplib-common-footer [baseUrl]="baseUrl" [menusBaseUrl]="menusBaseUrl"></fplib-common-footer>

@if (isDebug()) {
<pusher-activity-debug />
}